import { AUTH_DATA } from "../constants";

export const authData = (data) => {
  return {
    type: AUTH_DATA,
    data: data,
  };
};
